export interface Action {
    (): void;
}

export interface IAsyncServiceProvider<T>{
	instance:T,
	onInit:ng.IPromise<void>;
}

export interface Dimensions2D {
    height:number;
    width:number;
}

export type DeepPartial<T> = {
    [P in keyof T]?: DeepPartial<T[P]>;
}

export interface IDictionary<T> {
    [key:string]:T;
}

export type SyncOrAsync<T> = T | ng.IPromise<T>;
export type OneOrMany<T> = T | Array<T>;

export class MaxLengthArray<T> extends Array<T> {
    private maxLength: number;
    
    constructor(maxLength: number = 300) {
        super();
        this.maxLength = maxLength;
    }

    public push(...items:Array<T>): number {
        while(this.length + items.length > this.maxLength) {
			this.shift();
        }
        return super.push.apply(this, items);
    }
}

export interface NestedArray<T> extends Array<T|NestedArray<T>>{}

export type InterfaceFor<T> = {[K in keyof T]: T[K]}


// WEBPACK FOOTER //
// ./src/util/domain/standard-types.ts